import * as React from 'react';
import styled from 'styled-components';
import { sanitizeHtml } from 'utils/utils.html';
import { LimitLines, LimitLinesProps } from '../Common/LimitLines';
import { SIZES } from '../JRCTypography/JRCTypography.styles';

const Div = styled.div`
    ${LimitLines};

    * {
        overflow-wrap: anywhere;
    }

    // Default images

    img {
        max-width: 100%;
    }

    // Default links

    a {
        color: ${({ theme }) => theme.color.secondary};
    }

    // Default lists

    ul {
        margin-left: ${({ theme }) => theme.space.l}px;
        list-style-type: disc;
        list-style-position: inside;

        ul {
            list-style-type: circle;

            ul {
                list-style: square;
            }
        }
    }

    ol {
        margin-left: ${({ theme }) => theme.space.l}px;
        list-style-type: decimal;
        list-style-position: inside;
    }

    // Default tables

    td {
        border: 1px solid ${({ theme }) => theme.color.grey5};
        padding: ${({ theme }) => theme.space.xs}px;
    }

    // Default quotes

    blockquote {
        border-left: 2px solid ${({ theme }) => theme.color.grey3};
        margin-left: ${({ theme }) => theme.space.md}px;
        padding-left: ${({ theme }) => theme.space.sm}px;

        p {
            font-size: ${SIZES.m}px;
            color: ${({ theme }) => theme.color.grey5};
            font-weight: ${({ theme }) => theme.font.weight.normal};
        }
    }

    // Default horizontal lines

    hr {
        border-top: 1px solid ${({ theme }) => theme.color.grey3};
        margin: 0.5em 0;
    }

    pre {
        padding: ${({ theme }) => theme.space.sm}px ${({ theme }) => theme.space.md}px;
        background-color: ${({ theme }) => theme.color.grey0};
        border-radius: ${({ theme }) => theme.size.xs}px;
        border: 1px solid ${({ theme }) => theme.color.grey1};
    }

    iframe {
        max-width: 100%;
    }
`;

export type JRCHtmlProps = LimitLinesProps & {
    className?: string;
    as?: React.ElementType | keyof JSX.IntrinsicElements;
    __html: string | undefined;
};

const Html = ({ __html, ...props }: JRCHtmlProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    if (!__html) return null;

    return <Div {...props} dangerouslySetInnerHTML={{ __html: sanitizeHtml(__html) }} ref={ref} />;
};

export const JRCHtml = React.forwardRef(Html);
